import Component from 'vue-class-component'
import Vue from 'vue'
import feedStore from '../../store/feed/feed-store'

@Component({
  name: 'profile-section'
})
export default class ProfileSection extends Vue {
  get currUser () { return feedStore.state.feedUser }
}
